const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/portfolio/table/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import type { z } from 'zod';
import { getTeamsQueryOptions } from '@/lib/queries/teams/useGetTeamsQuery';
import i18n from '@/lib/translations/i18n';
import type { LoaderData } from '@/lib/types/common';
import { descendantItemFilterSearchSchema } from '@/lib/zod-schemas/descendantItemFilterSearchSchema';
import { integrationSearchSchema } from '@/lib/zod-schemas/integrationSearchSchema';
import { itemPanelSearchSchema } from '@/lib/zod-schemas/itemPanelSearchSchema';
const portfolioTableSchema = integrationSearchSchema.and(descendantItemFilterSearchSchema).and(itemPanelSearchSchema);
export type PortfolioTableRouteSearch = z.infer<typeof portfolioTableSchema>;
export const Route = createFileRoute('/(app)/org/$org/portfolio/table/')({
  validateSearch: zodValidator(portfolioTableSchema),
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  loader: async ({
    context: {
      queryClient
    }
  }): Promise<LoaderData> => {
    await queryClient.ensureQueryData(getTeamsQueryOptions());
    return {
      crumb: i18n.t('roadmapping.visualizationType.itemGrid')
    };
  },
  staticData: {
    topNav: {
      title: i18n.t('portfolio.title')
    }
  }
});